import type { DatabaseRow } from '../types/database.types'
import { DuplicatesRepository } from '../repositories/duplicates.repository'
import { unwrap } from './result'

export const ProspectDuplicateService = {
  async checkExact(
    parameters: Record<string, unknown>,
  ): Promise<DatabaseRow[]> {
    return unwrap(
      await DuplicatesRepository.check('check_prospect_duplicates', parameters),
    )
  },

  async checkSimilar(
    parameters: Record<string, unknown>,
  ): Promise<DatabaseRow[]> {
    return unwrap(
      await DuplicatesRepository.check(
        'find_similar_prospect_names',
        parameters,
      ),
    )
  },

  async check(
    functionName: string,
    parameters: Record<string, unknown>,
  ): Promise<DatabaseRow[]> {
    return unwrap(await DuplicatesRepository.check(functionName, parameters))
  },
}
